import React from 'react'
import View from './view.js'

export default function Logic(props) {
  return <View {...props} viewPath={props?.dsViewPath || props.viewPath} />
}
